// TODO: delete this component when useImprovedBrandFiltering FF removed
import { gql, useLazyQuery } from '@apollo/client'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import I18n from 'i18n-js'
import PropTypes from 'prop-types'
import { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { makeStyles } from 'tss-react/mui'

import { useFeatureFlag } from '@src/lib/useFeatureFlag'
import { selectCurrentRetailerAccountBrandsMenuData } from '@src/stores/mainMenu/selectors'

import useDebounceValue from '../../hooks/useDebounceValue'
import { currentRetailerAccountIdSelector } from '../../stores/app/selectors'
import { currentRetailerIdSelector } from '../../stores/retailers/selectors'
import Filter from '../shared/Filter'
import Search from '../shared/Search'

const useStyles = makeStyles()(() => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap-reverse',
    width: '100%',
    marginBottom: '32px',
  },
  field: {
    maxWidth: '25%',
  },
}))

const filterByItems = [
  { label: I18n.t('filters.popular'), value: 'popular' },
  { label: I18n.t('filters.facebook'), value: 'facebook' },
  { label: I18n.t('filters.twitter'), value: 'twitter' },
  { label: I18n.t('filters.instagram'), value: 'instagram' },
  { label: I18n.t('filters.email'), value: 'email' },
  { label: I18n.t('filters.downloadable'), value: 'asset' },
  { label: I18n.t('filters.webBanner'), value: 'embed' },
]

const GET_CAMPAIGNS_TAGS = gql`
  query GetCampaignsTagsContentPage(
    $resourceType: CampaignResourceType!
    $resourceId: ID!
  ) {
    getCampaignTags(resourceType: $resourceType, resourceId: $resourceId) {
      tags
    }
  }
`

const SearchAndFilters = ({ onChange }) => {
  const isNewSashEnabled = useFeatureFlag('new-sash')
  const { classes } = useStyles()
  const [searchValue, setSearchValue] = useState(null)
  const retailerAccountId = useSelector(currentRetailerAccountIdSelector)
  const retailerId = useSelector(currentRetailerIdSelector)
  const [getCampaignTags, { data, error, refetch, called }] =
    useLazyQuery(GET_CAMPAIGNS_TAGS)
  const debouncedSearchValue = useDebounceValue(searchValue, 500) //It's really that simple? :P
  const { brands } = useSelector(selectCurrentRetailerAccountBrandsMenuData)
  const useImprovedBrandFiltering = useFeatureFlag('improved-brand-filtering')
  const showItems = isNewSashEnabled
    ? [{ label: I18n.t('filters.current'), value: 'active' }]
    : [
        { label: I18n.t('filters.new'), value: 'new' },
        { label: I18n.t('filters.current'), value: 'active' },
      ]

  useEffect(() => {
    const variables = {
      resourceId: retailerId ? retailerId : retailerAccountId,
      resourceType: retailerId ? 'retailers' : 'retailer_accounts',
    }
    ;(called ? refetch(variables) : getCampaignTags({ variables })).catch(
      (error) => {
        console.error(error)
      },
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [retailerId, retailerAccountId])

  useEffect(() => {
    if (error) {
      console.error(error)
    }
  }, [error])

  useEffect(() => {
    if (debouncedSearchValue !== null) {
      onChange('searchValue', debouncedSearchValue)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedSearchValue])

  const onChangeSearchValue = (newSearchValue) => {
    setSearchValue(newSearchValue)
  }

  const tags = (data && data.getCampaignTags && data.getCampaignTags.tags) || []

  const tagsItems =
    (tags &&
      tags.map((tag) => {
        return {
          label: tag,
          value: tag,
        }
      })) ||
    []

  return (
    <Box className={classes.root}>
      <Grid container>
        {useImprovedBrandFiltering && (
          <Grid item sm={3} xs={12}>
            <Filter
              className={classes.field}
              label={I18n.t('filters.selectBrands')}
              items={
                brands &&
                brands.map((brand) => {
                  return {
                    label: brand.name,
                    slug: brand.slug,
                    id: brand.id,
                  }
                })
              }
              autoComplete
            />
          </Grid>
        )}
        <Grid item sm={3} xs={12}>
          <Filter
            className={classes.field}
            items={filterByItems}
            label={I18n.t('filters.channel')}
            onChange={(e) => onChange('filterByValue', e)}
          />
        </Grid>
        <Grid item sm={3} xs={12}>
          <Filter
            className={classes.field}
            items={showItems}
            label={I18n.t('filters.show')}
            onChange={(e) => onChange('showValue', e)}
          />
        </Grid>
        <Grid item sm={3} xs={12}>
          <Filter
            className={classes.field}
            items={tagsItems}
            label={I18n.t('filters.tags')}
            multiSelect
            onChange={(e) => onChange('tagsValues', e)}
          />
        </Grid>
        <Grid item sm={3} xs={12}>
          <Search className={classes.field} onChange={onChangeSearchValue} />
        </Grid>
      </Grid>
    </Box>
  )
}

SearchAndFilters.propTypes = {
  onChange: PropTypes.func,
}

export default SearchAndFilters
